<template>
    <div class="week">
        <button class="week-info" @click="zoomOut(date)">
            {{ getDate(date) }}
        </button>
    </div>
</template>

<script>
import { convert } from '@js-joda/core';
import { mapActions, mapState } from 'vuex';
import { ZOOM_SETTINGS } from '../../constants';

export default {
    data() {
        return {};
    },
    props: ['date'],
    computed: {
        ...mapState('planning', ['currentZoom', 'mode']),
    },
    methods: {
        ...mapActions('planning', ['zoomOut', 'zoomIn']),
        getDate(date) {
            const jsDate = convert(date.localDate).toDate();

            let options = {
                weekday: 'long',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            };

            return jsDate.toLocaleDateString(window.locale, options);
        },
    },
};
</script>

<style lang="scss" scoped>
.week {
    width: 1150px;
    &:nth-of-type(1) {
        width: 900px;
    }
    box-sizing: border-box;
    line-height: 25px;
    text-transform: uppercase;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-left: -1px;
    margin-right: -1px;
    &:last-child {
        border-right: 0;
    }
}
.week-info {
    display: block;
    width: 100%;
    line-height: 49px;
    border-bottom: 0;
    box-sizing: border-box;
    text-align: center;
    position: relative;
}
</style>


